var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19157_8257",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19157_8257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0009 32.8878H17.7012C17.6262 32.8878 17.526 32.8626 17.4006 32.8122C14.1756 31.8372 11.4693 29.8248 9.28172 26.775C7.09472 23.7252 6.00122 20.3001 6.00122 16.4997V9.22502C6.00122 8.70002 6.15122 8.22512 6.45122 7.80032C6.75122 7.37492 7.13852 7.06232 7.61312 6.86252L17.1387 3.30032C17.4387 3.20012 17.7261 3.15002 18.0009 3.15002C18.2757 3.15002 18.5631 3.20012 18.8631 3.30032L28.3887 6.86252C28.8633 7.06232 29.2506 7.37492 29.5506 7.80032C29.8506 8.22512 30.0006 8.70002 30.0006 9.22502V17.0622C29.3508 16.7622 28.6758 16.5249 27.9756 16.3503C27.276 16.1751 26.5635 16.0875 25.8381 16.0875C23.1381 16.0875 20.8443 17.0376 18.9567 18.9378C17.0697 20.8374 16.1262 23.1372 16.1262 25.8372C16.1262 27.1122 16.3698 28.3374 16.857 29.5128C17.3448 30.6876 18.051 31.725 18.9756 32.625C18.7758 32.7252 18.5946 32.7939 18.432 32.8311C18.2694 32.8689 18.1257 32.8878 18.0009 32.8878Z",
    fill: "#D22730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0252 26.0622C26.675 26.0622 27.2249 25.8309 27.6749 25.3683C28.1249 24.9057 28.3499 24.3495 28.3499 23.6997C28.3499 23.0499 28.1249 22.5063 27.6749 22.0689C27.2249 21.6309 26.675 21.4119 26.0252 21.4119C25.4 21.4119 24.8561 21.6309 24.3935 22.0689C23.9315 22.5063 23.7005 23.0499 23.7005 23.6997C23.7005 24.3495 23.9315 24.9057 24.3935 25.3683C24.8561 25.8309 25.4 26.0622 26.0252 26.0622ZM26.0252 30.6747C26.825 30.6747 27.5561 30.4998 28.2185 30.15C28.8815 29.7996 29.438 29.2995 29.888 28.6497C29.288 28.3245 28.6628 28.0746 28.0124 27.9C27.3626 27.7248 26.7002 27.6372 26.0252 27.6372C25.325 27.6372 24.65 27.7248 24.0002 27.9C23.3504 28.0746 22.7255 28.3245 22.1255 28.6497C22.5755 29.2995 23.1317 29.7996 23.7941 30.15C24.4565 30.4998 25.2002 30.6747 26.0252 30.6747ZM26.0999 33.3C24.1001 33.3 22.4003 32.5935 21.0005 31.1805C19.6001 29.7681 18.8999 28.0869 18.8999 26.1369C18.8999 24.1371 19.6001 22.431 21.0005 21.0186C22.4003 19.6062 24.1001 18.9 26.0999 18.9C28.0751 18.9 29.7689 19.6062 31.1813 21.0186C32.5937 22.431 33.2999 24.1371 33.2999 26.1369C33.2999 28.0869 32.5937 29.7681 31.1813 31.1805C29.7689 32.5935 28.0751 33.3 26.0999 33.3Z",
    fill: "#5575C6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAccount);
export default __webpack_public_path__ + "static/media/createAccount.e00d6538637f59b4411593e3a243f8bc.svg";
export { ForwardRef as ReactComponent };